import React from 'react';
import styles from './testimonials.module.scss';


class Testimonials extends React.Component {
  getChildren () {
    var arr = [];
    React.Children.map(this.props.children, function(child) {
      arr.push(<li className={styles.testimonial}>{child}</li>);
    })
    return arr;
  }
  render () {
    return (
      <div className={styles.wrapper}>
        <h2>{this.props.title}</h2>
        <ul className={styles.testimonials}>
          {this.getChildren()}
        </ul>
      </div>
    )
  }
}

export default Testimonials;


// WEBPACK FOOTER //
// ./src/components/Testimonials/index.js